import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-container" }
const _hoisted_2 = { class: "hero-content" }
const _hoisted_3 = { class: "status-badges" }
const _hoisted_4 = { class: "badge status-dev" }
const _hoisted_5 = { class: "badge focus-cka" }
const _hoisted_6 = { class: "hero-title" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "hero-actions" }
const _hoisted_11 = { class: "hero-pillars" }
const _hoisted_12 = { class: "pillar" }
const _hoisted_13 = { class: "pillar-text" }
const _hoisted_14 = { class: "pillar" }
const _hoisted_15 = { class: "pillar-text" }
const _hoisted_16 = { class: "pillar" }
const _hoisted_17 = { class: "pillar-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mdi mdi-code-braces" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('home.hero.badgeStatus')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mdi mdi-certificate" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('home.hero.badgeFocus')), 1)
        ])
      ]),
      _createElementVNode("h1", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('home.title')), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('home.subtitle')), 1)
      ]),
      _createElementVNode("p", {
        class: "hero-pitch",
        innerHTML: _ctx.$t('home.hero.pitch')
      }, null, 8, _hoisted_9),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "cta-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToInfra && _ctx.navigateToInfra(...args)))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mdi mdi-cloud-sync" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('home.hero.ctaInfra')), 1)
        ]),
        _createElementVNode("button", {
          class: "cta-secondary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToProjects && _ctx.navigateToProjects(...args)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mdi mdi-view-grid-outline" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('home.hero.ctaProjects')), 1)
        ])
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "hero-visual" }, [
      _createElementVNode("div", { class: "photo-frame" }, [
        _createElementVNode("img", {
          src: "/PP.png",
          alt: "Raphaël Girardy",
          class: "profile-photo"
        }),
        _createElementVNode("div", { class: "glass-overlay" })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mdi mdi-pillar" }, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.hero.pillarArch')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.hero.pillarArchDesc')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mdi mdi-kubernetes" }, null, -1)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.hero.pillarOrch')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.hero.pillarOrchDesc')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mdi mdi-shield-check-outline" }, null, -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.hero.pillarSec')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.hero.pillarSecDesc')), 1)
        ])
      ])
    ])
  ]))
}